var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyTeam = function SvgMyTeam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#MyTeam_svg__a)",
    fill: "#222"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16.5a1 1 0 1 1 0 2h-15a1 1 0 1 1 0-2h15ZM8.333 5.667a1 1 0 1 1 0 2H7.5a1 1 0 0 1 0-2h.833ZM8.333 9a1 1 0 0 1 0 2H7.5a1 1 0 1 1 0-2h.833ZM8.333 12.333a1 1 0 1 1 0 2H7.5a1 1 0 1 1 0-2h.833ZM12.5 5.667a1 1 0 1 1 0 2h-.833a1 1 0 1 1 0-2h.833ZM12.5 9a1 1 0 1 1 0 2h-.833a1 1 0 1 1 0-2h.833ZM12.5 12.333a1 1 0 1 1 0 2h-.833a1 1 0 1 1 0-2h.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.834 17.5V4.167a.668.668 0 0 0-.667-.667H5.834a.667.667 0 0 0-.667.667V17.5a1 1 0 1 1-2 0V4.167A2.667 2.667 0 0 1 5.834 1.5h8.333a2.667 2.667 0 0 1 2.667 2.667V17.5a1 1 0 0 1-2 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "MyTeam_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgMyTeam;